import { AddEvent, ViewEvent } from '~/passporter-services/shared/metrics'
import { BaseMetric } from './baseMetric'
import mixpanel from 'mixpanel-browser'

export class TripTravelerMetric extends BaseMetric {
	public static viewInvitationDialog(
		tripId: string,
		destinationName: string,
		userRole?: string,
		routeName?: string
	) {
		new ViewEvent('travelers', routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole || '')
			.send(this.gtag, mixpanel)
	}

	public static addTravelerEmail(
		tripId: string,
		destinationName: string,
		userRole?: string,
		routeName?: string
	) {
		new AddEvent('traveler_email', routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole || '')
			.send(this.gtag, mixpanel)
	}

	public static addTravelerLink(
		tripId: string,
		destinationName: string,
		userRole?: string,
		routeName?: string
	) {
		new AddEvent('traveler_link', routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole || '')
			.send(this.gtag, mixpanel)
	}
}
